export default {
      id: "recall-lg-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "svgsprite.svg#recall-lg",
      toString: function () {
        return this.url;
      }
    }